import { render } from "./DefaultLoading.vue?vue&type=template&id=2f12e934&scoped=true&ts=true"
import script from "./DefaultLoading.vue?vue&type=script&lang=ts"
export * from "./DefaultLoading.vue?vue&type=script&lang=ts"

import "./DefaultLoading.vue?vue&type=style&index=0&id=2f12e934&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f12e934"]])

export default __exports__